import http from "./httpService";
import auth from "./authService";

function supplierStoreUrl(id) {
  if (id) return `/v1/companies/${auth.getCurrentUser().company_id}/visas/${id}`;
  else return `/v1/companies/${auth.getCurrentUser().company_id}/visas`;
}

export function getAll() {
  return http.get(supplierStoreUrl());
}

export function deleteSingle(supplierId) {
  return http.delete(supplierStoreUrl(supplierId));
}

export function saveSingle(supplier) {
  return http.post(supplierStoreUrl(), supplier);
}

export function updateSingle(supplier) {
  return http.put(supplierStoreUrl(supplier.id), supplier);
}

export function updateSingleStatus(supplier) {
  return http.get(
    `/v1/companies/${auth.getCurrentUser().company_id}/visas/${supplier.id}/status`
  );
}

export function updateVisaType(data) {
  return http.post(`/v1/visas/${data.id}/change-type`, data);
}

export function getSingle(supplierId) {
  return http.get(supplierStoreUrl(supplierId));
}

export function getSingleVisa(supplierId, companyId) {
  return http.get(`/v1/companies/${companyId}/visas/${supplierId}`);
}

export function getAccountCompany(accountId) {
  return http.get(`/v1/get-company/visa/${accountId}`);
}

export function getLedgerAccountCompany(accountId) {
  return http.get(`/v1/get-ledger-account-company/visa/${accountId}`);
}
